import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveIdeaBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve idea</div>
          <div className="text">
            Retrieves the details of an existing idea, specified by its id or urlName.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                heading: 'apiKey',
                subheading: 'string',
                description: 'Your secret API key.',
              },
              {
                heading: 'id',
                subheading: 'string (optional)',
                description: "The idea's unique identifier.",
              },
              {
                heading: 'urlName',
                subheading: 'string (optional)',
                description: "The idea's unique urlName.",
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns an idea object, if a valid id or urlName was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/ideas/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/ideas/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba1238`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1238",
  "childCount": 0,
  "created": "${this.createdAt.toISOString()}",
  "description": "Test idea description",
  "author": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "owner": {
    "id": "553c3ef8b8cdcd1501ba1236",
    "created": "${this.createdAt.toISOString()}",
    "email": "john@example.com",
    "isAdmin": false,
    "name": "John Doe",
    "url": "https://your-company.canny.io/admin/users/john-doe",
    "userID": "1234"
  },
  "group": {
    "id": "553c3ef8b8cdcd1501ba1235",
    "name": "Feature Requests",
    "description": "Feature requests are ideas for new features or improvements to the product.",
    "urlName": "feature-requests"
  },
  "parent": {
    "id": "553c3ef8b8cdcd1501ba1237",
    "title": "Parent Idea",
    "urlName": "parent-idea"
  },
  "source": {
    "name": "canny",
    "type": "web"
  },
  "status": {
    "id": "553c3ef8b8cdcd1501ba2234",
    "name": "Under Review",
    "type": "Active",
    "urlName": "under-review"
  },
  "title": "An awesome feature request",
  "updatedAt": "${this.createdAt.toISOString()}",
  "urlName": "an-awesome-feature-request"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
